import { StarFilled } from '@carbon/icons-react';
import { colorSet } from '@components/Provider';
import React from 'react';

const CommentRatingStar = ({ rating }: { rating: number }) => {
  return (
    <div className="stars">
      {Array.from({ length: rating }).map((_, index) => (
        <StarFilled key={index + 100} size={16} color={colorSet.primary500} />
      ))}
      {Array.from({ length: 5 - rating }).map((_, index) => (
        <StarFilled key={index + 200} size={16} color={colorSet.gray300} />
      ))}
    </div>
  );
};

export default CommentRatingStar;
